import { Component, OnInit, Input, ViewChild, Inject  } from '@angular/core';
import { DataAlarm } from 'src/app/models/data-alarm';

import { MatAccordion } from '@angular/material/expansion';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';


export interface DialogData {
  id: string;
  title: string;
  description: string;
  isDisabled: boolean;
  isExpanded: boolean;
  tipo: string;
  horaIni: string;
  horaFin: string;
  estado: boolean;
  updateTimeIni: string;
  updateTiemEnd: string;
}


interface opcionSelect {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-alarma',
  templateUrl: './alarma.component.html',
  styleUrls: ['./alarma.component.scss']
})


export class AlarmaComponent implements OnInit {

  //cargamos los datos de la alarma
  @Input() dataAlarm: DataAlarm;

  
  
  // SELECT
  opcionesDisp: opcionSelect[] = [
    { value: "si se levanta",     viewValue: "si se levanta"},
    { value: "si no se levanta",     viewValue: "si no se levanta"}
  ];
  selectOpcion1 = this.opcionesDisp[0].value;
  selectedDisp1 = this.opcionesDisp[0].value;

 
  
  panelOpenState = false;

  accordionList:any;

  @ViewChild('accordion',{static:true}) Accordion: MatAccordion;

  constructor(public dialog: MatDialog) {
    this.accordionList = [
      {
        id:"panel-1",
        title:"Panel One",
        description:"Description One",
        isDisabled:false,
        isExpanded:false,
        tipo: "si se levanta",
        horaIni: "01:00",
        horaFin: "02:00",
        estado: false,
        updateTimeIni: "",
        updateTiemEnd: ""
      },{
        id:"panel-2",
        title:"Panel Two (Disabled)",
        description:"Description Two",
        isDisabled:false,
        isExpanded:false,
        tipo: "si no se levanta",
        horaIni: "05:00",
        horaFin: "02:00",
        estado: true,
        updateTimeIni: "",
        updateTiemEnd: ""
      },{
        id:"panel-3",
        title:"Panel Three",
        description:"Description Three",
        isDisabled:false,
        isExpanded:false,
        tipo: "si se levanta",
        horaIni: "04:00",
        horaFin: "05:00",
        estado: true,
        updateTimeIni: "",
        updateTiemEnd: ""
      },
    ];
   }

   //opciones del compoenete showDialog

   openDialog(): void {
    const dialogRef = this.dialog.open(AddAlarmDialog, {
      width: '250px',
      data: { id:"panel-3",
              title:"Panel Three",
              description:"Description Three",
              isDisabled:false,
              isExpanded:false,
              tipo: "si se levanta",
              horaIni: "04:00",
              horaFin: "05:00",
              estado: true,
              updateTimeIni: "",
              updateTiemEnd: "" }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      // this.animal = result;
    });
  }

//opciones Del compoenete Dist
  ngOnInit() {
  }

  OnOptionEvent() {
    console.log('Evento', this.selectedDisp1);
  }

  onTimeIni(event, panel) {
    console.log('Fecha Inicial:', event);
    panel.updateTimeIni  = event;
  }

  onTimeFin(event, panel) {
    console.log('Fecha Final', event);
    panel.updateTiemEnd = event;
  }

  //aaciones de los paneles

  beforePanelClosed(panel){
    panel.isExpanded = false;
    console.log("Panel going to close!");
    
  }
  beforePanelOpened(panel){
    panel.isExpanded = true;
    console.log("Panel going to  open!");
  }

  afterPanelClosed(){
    
    console.log("Panel closed!");
  }
  afterPanelOpened(){
    console.log("Panel opened!");
  }


  closeAllPanels(){
    this.Accordion.closeAll();
  }
  openAllPanels(){
    this.Accordion.openAll();
  }

  // Obtenemos el valor del id y asignamos los cambios,
  // ,comprobamos si los compoenetes fueron modificados por el usuario y adaptamos la insercion
  save(panel, option){

    for ( let p of this.accordionList){
        if (p.id === panel.id){
          p.horaIni = panel.updateTimeIni;
          p.horaFin = panel.updateTiemEnd;
          panel.updateTimeIni = "";
          panel.updateTiemEnd = "";
        //  p.estado = option.value;
        }
    }
    console.log(this.accordionList);


  }

  deleteData(panel){
    this.accordionList.forEach((value,index)=>{
      if(value.id ==panel.id) this.accordionList.splice(index,1);
      });
    console.log(this.accordionList);
  }


  onAddAlarm(){

  }
}

@Component({
  selector: 'app-add-alarm-dialog',
  templateUrl: './addalarmdialog.html',
})
export class AddAlarmDialog {

  constructor(
    public dialogRef: MatDialogRef<AddAlarmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  OnOptionEvent1(){

  }

  onTimeIni(event, data){

  }

  onTimeFin(event, data){
    
  }

}
